<template>
    <dialog-template
        :headerTitle="headerTitle"
        v-bind="$attrs"
        v-on="$listeners"
        :visible="showDialog"
        :width="width">
        <slot/>
        <div class="footer" slot="footer">
            <el-button type="primary" size="medium" @click="confirm" :disabled="!canUse">{{ confirmText }}</el-button>
            <el-button type="default" size="medium" @click="$emit('close')">{{ concelText }}</el-button>
        </div>
    </dialog-template>
</template>

<script>
export default {
    props: {
        headerTitle: {
            type: String,
            default: ''
        },
        width: {
            type: String,
            default: '400px'
        },
        canUse: {
            type: Boolean,
            default: false
        },
        confirmText: {
            type: String,
            default: '确认'
        },
        concelText: {
            type: String,
            default: '取消'
        },
        showDialog: Boolean
    },
    methods: {
        confirm() {
            if (this.lock) {
                return
            }
            this.lock = true
            const cb = () => {
                setTimeout(() => {
                    this.lock = false
                }, 600)
            }
            this.$emit('confirm', cb)
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {

    .el-dialog__title {
        font-weight: 500 !important;
        color: #333;
    }

    .el-dialog__body {
        padding: 20px 12px !important;
    }

    .el-dialog__footer {
        height: auto;
        line-height: 1;
        padding-bottom: 12px;
    }
}

.footer {
    text-align: center;
}
</style>
